import { LANGUAGES } from '../../constants';
import { StyleLayout } from '../components';
import type { StyleProps } from './types';

export function Style8({ items, onClick }: StyleProps) {
  return items?.map(({ id, language }, _, { length }) => {
    const { flag, originalName } = LANGUAGES[language];
    const handleClick = () => onClick(language);

    return (
      <StyleLayout.Container
        key={id}
        itemsLength={length}
        languageCode={language}
        onClick={handleClick}
        withSlash
      >
        <StyleLayout.Flag icon={flag} style="rounded" isDecorative />
        <StyleLayout.Name name={originalName} />
      </StyleLayout.Container>
    );
  });
}
